import axios from 'axios'
import { verifyPassword } from ".//posAccounts"

export async function getAsocias() {
    try {
        const response = await axios.get('https://finance.volteonelectronics.com/api/index.php/thirdparties?sortfield=t.rowid&sortorder=ASC&limit=100&mode=1&category=48', {
            headers: {
                'Accept': 'application/json',
                'DOLAPIKEY': 'CY70Rcki5B4V7ZbKaR3V9A6pOnmr71vh'
            }
        });
        return response.data; // Retorna la lista de asocias
    } catch (error) {
        console.error('Error al obtener usuarios:', error.response ? error.response.data : error.message);
        throw error;
    }
};

export async function loginAsocias(asociaData) {
    try {
        if (!asociaData || !asociaData.userName || !asociaData.password) {
            console.log("Datos incorrectos");
            return { success: false, message: 'Datos de usuario incompletos' };
        }

        const asocias = await getAsocias();
        const asocia = asocias.find(u => u.name_alias === asociaData.userName);

        if (!asocia) {
            console.log("Asocia no encontrada");
            return { success: false, message: 'Asociación no encontrada' };
        }

        const passwordMatch = await verifyPassword(asociaData.password, asocia.idprof1);

        if (!passwordMatch) {
            console.log("Contrasena incorrecta");
            return { success: false, message: 'Contraseña incorrecta' };
        }

        return {
            success: true,
            data: {
                name: asocia.name_alias,
                id: asocia.id 
            }
        };

    } catch (error) {
        console.error('Error al iniciar sesión:', error);
        return { success: false, message: 'Error en la verificación del usuario' };
    }
}
